import styled, { css } from 'styled-components';
import colors from '../../../helpers/colors';
import fonts from '../../../helpers/fonts';
import mediaQuery from '../../../helpers/mediaQuery';
import spacing from '../../../helpers/spacing';
import { GridItem } from '../../Grid';
import Link from '../../Link';

const BANNER_HEIGHT = '408px';
const BANNER_HEIGHT_MOBILE = '404px';
const BIG_TRIANGLE_WIDTH = '143vw';
const BIG_TRIANGLE_WIDTH_MOBILE = '432vw';
const SMALL_TRIANGLE_HEIGHT = '285px';
const SMALL_TRIANGLE_HEIGHT_MOBILE = '360px';
const SMALL_TRIANGLE_WIDTH = '36vw';
const SMALL_TRIANGLE_WIDTH_MOBILE = '250vw';

export const Heading = styled.h1<{ backButton?: boolean }>`
  ${fonts.headingXLarge}

  margin: 0;

  margin-top: ${({ backButton }) => (backButton ? spacing(6) : spacing(4))};
  ${mediaQuery.tabletPortrait`
    margin-top: ${({ backButton }) => (backButton ? spacing(4) : spacing(6))};
  `}

  & {
    color: ${colors.neutral08};
  }
`;

export const Subhead = styled.p`
  ${fonts.paragraph}
  margin: ${spacing(2)} 0 0;

  & {
    color: ${colors.neutral08};
  }

  ${mediaQuery.tabletPortrait`
    padding-right: ${spacing(8)};
  `}
`;

const bigTriangleStyles = css`
  content: ' ';
  position: absolute;
  left: 0;
  height: 0;
  width: 0;
  z-index: -1;

  border-top: ${BANNER_HEIGHT_MOBILE} solid ${colors.core01};
  border-right: ${BIG_TRIANGLE_WIDTH_MOBILE} solid transparent;

  ${mediaQuery.tabletPortrait`
    border-top: ${BANNER_HEIGHT} solid ${colors.core01};
    border-right: ${BIG_TRIANGLE_WIDTH} solid transparent;
  `}
`;

const smallTriangleStyles = css`
  content: ' ';
  position: absolute;
  top: 0;
  right: 0;
  height: 0;
  width: 0;
  z-index: -2;

  border-right: ${SMALL_TRIANGLE_WIDTH_MOBILE} solid ${colors.core02};
  border-bottom: ${SMALL_TRIANGLE_HEIGHT_MOBILE} solid transparent;

  ${mediaQuery.tabletPortrait`
    border-right: ${SMALL_TRIANGLE_WIDTH} solid ${colors.core02};
    border-bottom: ${SMALL_TRIANGLE_HEIGHT} solid transparent;
  `}
`;

export const OrigamiBackground = styled.div`
  position: relative;
  overflow: hidden;

  /* takes background to full screen */
  margin: 0 calc(50% - 50vw) ${spacing(4)};
  /* resets the content back to the grid */
  padding: 0 calc(50vw - 50%);

  height: ${BANNER_HEIGHT_MOBILE};

  ${mediaQuery.tabletPortrait`
      height: ${BANNER_HEIGHT};
  `}

  ${mediaQuery.tabletLandscape`
      margin-bottom: 0;
  `}

  /* Large triangle on the left */
  &::before {
    ${bigTriangleStyles}
  }

  /* Smaller triangle on the right */
  &::after {
    ${smallTriangleStyles}
  }
`;

export const IconWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-right: ${spacing(1)};
  margin-top: ${spacing(1)};
`;

export const StyledGridItem = styled(GridItem)`
  ${mediaQuery.tabletLandscape`
    display: none;
  `}
`;

export const StyledButtonLink = styled(Link)`
  ${fonts.paragraphLarge}
  & {
    color: white;
    font-weight: normal;
  }

  display: block;
  margin-top: ${spacing(4)};
  text-decoration: underline;

  ${mediaQuery.tabletPortrait`
    margin-top: ${spacing(6)};
  `}

  &:hover,
  &:focus-visible {
    color: white;
    text-decoration: none;
  }
  &:focus-visible {
    &:after {
      box-shadow: 0px 0px 0 2px ${colors.neutral08};
    }
  }
`;

export const ButtonWrapper = styled.div`
  display: flex;
`;
